/** Mensagem pronta para a tela (o backend devolve { message } em pt-BR). */
export function contactEmailErrorMessage(error: unknown, fallback = 'Não foi possível concluir agora.'): string {
  const data = (error as { response?: { data?: { message?: string } } })?.response?.data;
  return (data && typeof data.message === 'string' && data.message.trim()) || fallback;
}

/** 403 = usuário sem o módulo de e-mail: a conversa segue só com o WhatsApp. */
export function isEmailForbidden(error: unknown): boolean {
  return (error as { response?: { status?: number } })?.response?.status === 403;
}
